import Box from '@mui/material/Box';
import * as React from 'react';
import Toast from '../Toast';
import { jsx as _jsx } from "react/jsx-runtime";
const placementStyles = {
  top: {},
  'top-left': {
    right: 'auto'
  },
  'top-right': {
    left: 'auto'
  },
  bottom: {
    justifyContent: 'flex-end'
  },
  'bottom-left': {
    justifyContent: 'flex-end',
    right: 'auto'
  },
  'bottom-right': {
    justifyContent: 'flex-end',
    left: 'auto'
  }
};
const isCorner = placement => placement.includes('-');
function Toaster(props) {
  const {
    placement = 'top-right',
    toasts,
    onDismiss
  } = props;
  const makeOnDimiss = React.useCallback(toast => {
    if (!onDismiss) {
      return undefined;
    }
    return () => {
      onDismiss(toast.id, toast);
    };
  }, [onDismiss]);
  return _jsx(Box, {
    sx: {
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      zIndex: theme => theme.zIndex.snackbar,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      pointerEvents: 'none',
      ...placementStyles[placement]
    },
    "data-screenshot-ignore": true,
    children: toasts.map(toast => {
      return _jsx(Box, {
        sx: {
          pointerEvents: 'auto',
          maxWidth: isCorner(placement) ? 344 : undefined,
          overflowY: placement === 'bottom' ? 'auto' : undefined
        },
        children: _jsx(Toast, {
          variant: toast.type,
          timeout: toast.timeout,
          disableProgress: toast.disableProgress,
          onClose: makeOnDimiss(toast),
          children: toast.body
        })
      }, toast.id);
    })
  });
}
export default Toaster;